export enum PaymentTermType {
  Standard = 'STANDARD',
  Monthly = 'MONTHLY',
}
